/**
 * Main app component and high-level layout.
 */
import React from "react";
import { connect } from "react-redux";
import "react-notifications/lib/notifications.css";
import "react-image-gallery/styles/css/image-gallery.css";
import { NotificationContainer } from "react-notifications";
import Chat from "./Components/Chat";
import { isConfigLoaded } from "./store";
import { Show } from "./lib/utils";

import { checkFamilyAssetsSession, loadChatConfig, loadUrlConfig } from "./actions";
import type { GlobalState } from "./lib/types";

// import Rollbar from 'rollbar/dist/rollbar.noconflict.umd';

class App extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  //   this.state = {
  //     rollbar: new Rollbar({
  //       accessToken: "c46b0a1dbe06441dba77384c42941c9d",
  //       captureUncaught: true,
  //       captureUnhandledRejections: true,
  //     })
  //   };
  // }

  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(loadUrlConfig());
    dispatch(checkFamilyAssetsSession());
    dispatch(loadChatConfig());
  };

  savePopoverRef = (ref) => {
    window.famPopoverRef = ref;
  };

  saveIframeContainerRef = (ref) => {
    window.famIframeContainerRef = ref;
  };

  render() {
    const { isLoaded } = this.props;
    return (
      <>
        <div ref={this.saveIframeContainerRef} style={{ display: "none" }} />
        <Show when={isLoaded}>
          <Chat />
        </Show>
        <div id="popover" ref={this.savePopoverRef} />
      </>
    );
  }
}

/**
 * Map state to props.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  const { familyAssetsAdmin } = state;
  return {
    isLoaded: isConfigLoaded(state),
    familyAssetsAdmin,
  };
}

export default connect(mapStateToProps)(App);
